import "../styles/premium-motion.css";
import { useEffect, useRef, useState } from "react";

/**
 * Hook: fade-in-up when element enters viewport (once).
 * Attach ref, and add class 'gf-reveal' to the element in JSX.
 */
export default function useReveal(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      el.classList.add("gf-in");
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            el.classList.add("gf-in");
            io.unobserve(el);
          }
        });
      },
      { rootMargin: "0px 0px -60px 0px", threshold: 0.1, ...options }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return [ref, visible];
}
